import { UrlMatchResult, UrlSegment } from "@angular/router";

import { GuardGuard } from "../guard/guard.guard";
import { PreferenceGuard } from "../guard/preferences.guard";

import { LayoutComponent } from "../layout/default/layout.component";
import { FreeNasLayoutComponent } from "../layout/free-nas/layout.component";
import { landingMatcher } from "./Pages/landing_2026/landing.matcher";

/**
 * Activa ciclos y siembras dentro de Free NAS solo cuando la url empieza con
 * "ciclos-siembras". Con path "" la ruta lazy tambien capturaba "/free-nas" vacio
 * y dejaba la lista de estanques sin renderizar.
 * @param segments - Segmentos restantes de la url.
 * @returns Coincidencia sin consumir segmentos, o null si no aplica.
 */
export function freeNasCyclesMatcher(segments: UrlSegment[]): UrlMatchResult {
  return segments.length > 0 && segments[0].path === "ciclos-siembras" ? { consumed: [] } : null;
}

export const routes = [
  /* Landing publica 2026: "/" para visitantes sin sesion y "/productos/<slug>" */
  {
    matcher: landingMatcher,
    loadChildren: () => import("./Pages/landing_2026/landing.module").then((m) => m.LandingModule)
  },
  /* Modulo Free NAS: layout propio sin sidebar */
  {
    path: "free-nas",
    component: FreeNasLayoutComponent,
    canActivate: [GuardGuard, PreferenceGuard],
    children: [
      /* Ciclos y siembras de la vista normal, dentro del layout de Free NAS. Va antes
         del modulo de estanques para que ":pond_id" no capture "ciclos-siembras" */
      {
        matcher: freeNasCyclesMatcher,
        loadChildren: () =>
          import("./Clients/cycles-plantings/cycles-plantings.module").then(
            (m) => m.CyclesPlantingsModule
          )
      },
      {
        path: "",
        loadChildren: () => import("./Free-nas/free-nas.module").then((m) => m.FreeNasModule)
      }
    ]
  },
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "",
        redirectTo: "/",
        pathMatch: "full"
      },
      /* Modulo para administradores */
      {
        path: "",
        loadChildren: () => import("./Admin/admin.module").then((m) => m.AdminModule),
        canActivate: [GuardGuard, PreferenceGuard]
      },
      /* Ambos */
      {
        path: "alimentadoras",
        loadChildren: () =>
          import("./Admin/feeders/pages/management/management.module").then(
            (m) => m.FeedersManagementModule
          ),
        canActivate: [GuardGuard, PreferenceGuard],
        data: {
          permission: "view_feeder"
        }
      },
      /* Modulo para clientes */
      {
        path: "",
        loadChildren: () => import("./Clients/client.module").then((m) => m.ClientModule),
        canActivate: [GuardGuard, PreferenceGuard]
      }
    ]
  },
  {
    path: "",
    loadChildren: () => import("./Pages/pages.module").then((m) => m.PagesModule)
  }
];
